import React, { useState, useEffect } from 'react';
import { Search, Plus, X, ArrowLeft, Settings, Trash2, RefreshCcw, Upload, FileJson, CheckCircle } from 'lucide-react';

// API Service
const apiService = {
  baseUrl: process.env.REACT_APP_API_HOST || 'http://localhost:5100/api/v1/glossary',
  apiKey: process.env.REACT_APP_API_KEY || '12345',
  
  
  
  getHeaders() {
    return {
      'Content-Type': 'application/json',
      'x-api-key': `${this.apiKey}`
    };
  },
  
  async getGlossary(orgId, argument) {
    const url = `${this.baseUrl}/${orgId}/${argument}/export`;
    console.log('GET Glossary:', url);
    const response = await fetch(url, {method: 'POST',  headers: this.getHeaders(), body: JSON.stringify([]) });
    console.log('Response status:', response.status);
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error response:', errorText);
      throw new Error(`Failed to load glossary: ${response.status}`);
    }
    return response.json();
  },

  async deleteGlossary(orgId, argument) {
    const url = `${this.baseUrl}/${orgId}/${argument}`;
    console.log('DELETE Glossary:', url);
    const response = await fetch(url, {method: 'DELETE',  headers: this.getHeaders(), body: JSON.stringify([]) });
    console.log('Response status:', response.status);
    if (!response.ok) {
      throw new Error(`Failed to delete glossary: ${response.status}`);
    }
    return response;
  },
  
  async insertWord(orgId, argument, payload) {
    const url = `${this.baseUrl}/${orgId}/${argument}/add-word`;
    console.log('POST Insert Word:', url, payload);
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify(payload)
      });
      console.log('Response status:', response.status);
      
      
      // Gestisci in base a isSuccess e isWarning
      if (response.status === 200) {
        const result = await response.json();
        console.log('Response data:', result);
        // Sempre 200, ma controlla isSuccess e isWarning
        return { 
          ok: result.isSuccess, 
          data: result,
          type: result.isWarning ? 'warning' : (result.isSuccess ? 'success' : 'error')
        };
      } else {
        // Errore 500 o altri
        return { 
          ok: false, 
          data: response,
          type: 'error'
        };
      }
    } catch (error) {
      console.error('Network error:', error);
      throw error;
    }
  },

  async deleteWord(orgId, argument, word, language) {
  const url = `${this.baseUrl}/${orgId}/${argument}/delete-word`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: this.getHeaders(),
      body: JSON.stringify({ Word: word, Language: language })
    });
    
    
    try {
     const result = await response.json();
        console.log('Response data:', result);
        // Sempre 200, ma controlla isSuccess e isWarning
        return { 
          ok: result.isSuccess, 
          data: result,
          type: result.isWarning ? 'warning' : (result.isSuccess ? 'success' : 'error')
        };
    } catch (parseError) {
      return { 
          ok: false, 
          data: response,
          type: 'error'
        };
    }
  } catch (error) {
    console.error('Network error:', error);
    throw error;
  }
},

  async importGlossary(orgId, argument, importData) {
    const url = `${this.baseUrl}/${orgId}/${argument}/import`;
    console.log('POST Import Glossary:', url, importData);
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify(importData)
      });
      console.log('Response status:', response.status);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        throw new Error(`Import fallito: ${response.status}`);
      }
      
      return { ok: true, type: 'success' };
    } catch (error) {
      console.error('Network error:', error);
      throw error;
    }
  },

  async checkSimilarWords(orgId, argument, word, language) {
    const url = `${this.baseUrl}/${orgId}/${argument}/check`;
    console.log('POST Check Similar Words:', url, { word, language });
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify({ word, language })
      });
      console.log('Response status:', response.status);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        throw new Error(`Check fallito: ${response.status}`);
      }
      
      const result = await response.json();
      console.log('Similar words response:', result);
      return result;
    } catch (error) {
      console.error('Network error:', error);
      throw error;
    }
  },

  async testGlossary(orgId, argument, payload) {
    const url = `${this.baseUrl}/${orgId}/${argument}/test-glossary`;
    console.log('POST Test Glossary:', url, payload);
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify(payload)
      });
      console.log('Response status:', response.status);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        throw new Error(`Test glossary fallito: ${response.status}`);
      }
      
      const result = await response.text();
      return result;
    } catch (error) {
      console.error('Network error:', error);
      throw error;
    }
  }
};

// Message Component
const Message = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 15000);
    return () => clearTimeout(timer);
  }, [onClose]);
  
  const colors = {
    success: 'bg-green-100 text-green-800 border-green-300',
    error: 'bg-red-100 text-red-800 border-red-300',
    warning: 'bg-yellow-100 text-yellow-800 border-yellow-300'
  };
  
  return (
    <div className={`p-3 rounded border ${colors[type]} mb-4 flex justify-between items-center`}>
      <span>{message}</span>
      <button onClick={onClose} className="ml-4">
        <X size={18} />
      </button>
    </div>
  );
};

// Similar Words Modal Component
const SimilarWordsModal = ({ similarWords, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-2xl max-h-[80vh] overflow-auto shadow-xl">
        <div className="flex justify-between items-center mb-4 border-b pb-3">
          <h3 className="text-xl font-bold text-gray-800">Parole Simili Trovate</h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X size={24} />
          </button>
        </div>
        
        {similarWords.length === 0 ? (
          <div className="text-center py-10 text-gray-500">
            <p className="text-lg">Nessuna parola simile trovata</p>
          </div>
        ) : (
          <div className="space-y-3">
            {similarWords.map((wordRef, index) => (
              <div 
                key={index} 
                className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-lg font-semibold text-gray-800">
                      {wordRef.word}
                    </span>
                    <span className="ml-3 text-sm text-gray-600 bg-gray-100 px-2 py-1 rounded">
                      {wordRef.language}
                    </span>
                  </div>
                  {wordRef.similarity && (
                    <span className="text-sm font-medium text-green-600 bg-green-50 px-3 py-1 rounded-full">
                      {(wordRef.similarity * 100).toFixed(1)}% simile
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
        
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
          >
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );
};

// Test Glossary Modal Component
const TestGlossaryModal = ({ orgId, argument, onClose }) => {
  const [jsonInput, setJsonInput] = useState('');
  const [inputLanguage, setInputLanguage] = useState('Italian');
  const [outputLanguage, setOutputLanguage] = useState('English');
  const [similarityThreshold, setSimilarityThreshold] = useState('0.7');
  const [topK, setTopK] = useState('5');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState('');
  const [showResult, setShowResult] = useState(false);

  const languages = ['English', 'Italian', 'Spanish', 'French', 'German'];

  const exampleTU = `[
  {
    "1": [
      {
        "2": [
          "Le partecipazioni di maggioranza sono un esempio utile per testare questa funzionalità",
          {
            "3": [
              "Per avere un'ottima performance si deve lavorare sodo"
            ]
          },
          "L'extra rendimento è diviso a tutti"
        ]
      }
    ]
  }
]`;

  const loadExample = () => {
    setJsonInput(exampleTU);
  };

  const handleTest = async () => {
    if (!jsonInput.trim()) {
      alert('Inserisci un JSON valido');
      return;
    }

    setLoading(true);
    try {
      const parsedJson = JSON.parse(jsonInput);
      
      const payload = {
        InputLanguage: inputLanguage,
        OutputLanguage: outputLanguage,
        TU: parsedJson,
        SimilarityThreshold: parseFloat(similarityThreshold),
        TopK: parseInt(topK)
      };

      const response = await apiService.testGlossary(orgId, argument, payload);
      setResult(response);
      setShowResult(true);
    } catch (error) {
      if (error instanceof SyntaxError) {
        alert('Errore: JSON non valido. Controlla la sintassi.');
      } else {
        alert(`Errore: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  if (showResult) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 max-w-4xl w-full max-h-[90vh] overflow-auto shadow-xl">
          <div className="flex justify-between items-center mb-4 border-b pb-3">
            <h3 className="text-xl font-bold text-gray-800">Prompt Utilizzato</h3>
            
            <button 
              onClick={() => {
                setShowResult(false);
                setResult('');
              }}
              className="text-gray-500 hover:text-gray-700"
            >
              <X size={24} />
            </button>
          </div>
          
          <div className="bg-gray-50 p-4 rounded border border-gray-200 mb-4">
            <pre className="whitespace-pre-wrap text-sm font-mono overflow-x-auto">
              {result}
            </pre>
          </div>
          <div>
            <h4 >Gli esempi e l'hint dipendono dall'esecuzione della traduzione con il document id in input quindi in questa fase di test non sono caricati nel prompt.</h4>
          </div>

          <div className="flex justify-end gap-2">
            <button
              onClick={() => {
                setShowResult(false);
                setResult('');
              }}
              className="px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
            >
              Torna al Form
            </button>
            <button
              onClick={onClose}
              className="px-6 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
            >
              Chiudi
            </button>
          </div>
        </div>
      </div>
    );
  }

  const Tooltip = ({ text }) => (
    <div className="group relative inline-block ml-1">
      <span className="cursor-help text-blue-500 hover:text-blue-700">ⓘ</span>
      <div className="invisible group-hover:visible absolute z-50 w-64 p-2 bg-gray-900 text-white text-xs rounded shadow-lg -top-2 left-6">
        {text}
      </div>
    </div>
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-3xl w-full max-h-[90vh] overflow-auto shadow-xl">
        <div className="flex justify-between items-center mb-4 border-b pb-3">
          <h3 className="text-xl font-bold text-gray-800">Test Translation Unit</h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X size={24} />
          </button>
        </div>
        
        <div className="space-y-4">
          <div>
            <div className="flex items-center justify-between mb-2">
              <label className="flex items-center text-sm font-medium">
                JSON TU:
                <Tooltip text="Translation Unit in formato JSON. Inserisci la struttura che rappresenta il testo da tradurre." />
              </label>
              <button
                onClick={loadExample}
                className="px-3 py-1 text-xs bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
              >
                Carica Esempio
              </button>
            </div>
            <textarea
              value={jsonInput}
              onChange={(e) => setJsonInput(e.target.value)}
              placeholder='[{"1": [{"2": ["Testo da tradurre"]}]}]'
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 font-mono text-sm"
              rows={10}
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="flex items-center text-sm font-medium mb-2">
                Lingua Input:
                <Tooltip text="La lingua della TU." />
              </label>
              <select
                value={inputLanguage}
                onChange={(e) => setInputLanguage(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {languages.map(lang => (
                  <option key={lang} value={lang}>{lang}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="flex items-center text-sm font-medium mb-2">
                Lingua Output:
                <Tooltip text="La lingua target per la traduzione." />
              </label>
              <select
                value={outputLanguage}
                onChange={(e) => setOutputLanguage(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {languages.map(lang => (
                  <option key={lang} value={lang}>{lang}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="flex items-center text-sm font-medium mb-2">
                Similarity Threshold:
                <Tooltip text="Soglia di similarità (0-1) per trovare parole simili nel glossario. Valori più bassi includono più risultati. Default 0.7" />
              </label>
              <input
                type="number"
                step="0.1"
                min="0"
                max="1"
                value={similarityThreshold}
                onChange={(e) => setSimilarityThreshold(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="flex items-center text-sm font-medium mb-2">
                Top K:
                <Tooltip text="Numero massimo di parole da recuperare dal glossario per la TU." />
              </label>
              <input
                type="number"
                min="1"
                value={topK}
                onChange={(e) => setTopK(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
          >
            Annulla
          </button>
          <button
            onClick={handleTest}
            disabled={loading}
            className="px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors disabled:bg-gray-400"
          >
            {loading ? 'Elaborazione...' : 'Esegui Test'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Import Modal Component
const ImportModal = ({ orgId, argument, onSuccess, onClose }) => {
  const [jsonInput, setJsonInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const exampleJson = {
  "1": [
    { "Word": "hello", "Language": "English" },
    { "Word": "ciao", "Language": "Italian" },
    { "Word": "bonjour", "Language": "French" },
    { "Word": "hola", "Language": "Spanish" },
    { "Word": "hallo", "Language": "German" }
  ],
  "2": [
    { "Word": "water", "Language": "English" },
    { "Word": "acqua", "Language": "Italian" },
    { "Word": "eau", "Language": "French" },
    { "Word": "agua", "Language": "Spanish" },
    { "Word": "wasser", "Language": "German" }
  ],
  "3": [
    { "Word": "book", "Language": "English" },
    { "Word": "libro", "Language": "Italian" },
    { "Word": "livre", "Language": "French" },
    { "Word": "libro", "Language": "Spanish" },
    { "Word": "buch", "Language": "German" }
  ],
  "4": [
    { "Word": "house", "Language": "English" },
    { "Word": "casa", "Language": "Italian" },
    { "Word": "maison", "Language": "French" },
    { "Word": "casa", "Language": "Spanish" },
    { "Word": "haus", "Language": "German" }
  ],
  "5": [
    { "Word": "time", "Language": "English" },
    { "Word": "tempo", "Language": "Italian" },
    { "Word": "temps", "Language": "French" },
    { "Word": "tiempo", "Language": "Spanish" },
    { "Word": "zeit", "Language": "German" }
  ]
};

  const handleImport = async () => {
    setError('');
    
    if (!jsonInput.trim()) {
      setError('Inserisci un JSON valido');
      return;
    }

    try {
      // Valida il JSON
      const parsedJson = JSON.parse(jsonInput);
      
      // Valida la struttura
      if (typeof parsedJson !== 'object' || Array.isArray(parsedJson)) {
        setError('Il JSON deve essere un oggetto con chiavi numeriche');
        return;
      }

      // Converti le chiavi in numeri
      const importData = {};
      for (const [key, value] of Object.entries(parsedJson)) {
        const numKey = parseInt(key);
        if (isNaN(numKey)) {
          setError(`La chiave "${key}" non è un numero valido`);
          return;
        }
        
        if (!Array.isArray(value)) {
          setError(`Il valore per la chiave ${key} deve essere un array`);
          return;
        }

        // Valida ogni WordReference
        for (const word of value) {
          if (!word.Word || !word.Language) {
            setError(`Ogni elemento deve avere "Word" e "Language"`);
            return;
          }
        }

        importData[numKey] = value;
      }

      setLoading(true);

      // Effettua l'import
      await apiService.importGlossary(orgId, argument, importData);
      onSuccess('Import completato con successo!', 'success');
      onClose();

    } catch (error) {
      if (error instanceof SyntaxError) {
        setError('JSON non valido: ' + error.message);
      } else {
        setError('Errore durante l\'import: ' + error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const loadExample = () => {
    setJsonInput(JSON.stringify(exampleJson, null, 2));
    setError('');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <FileJson size={24} className="text-blue-600" />
            <h3 className="text-xl font-semibold">Import Glossario JSON</h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X size={24} />
          </button>
        </div>

        <div className="p-6">
          <div className="mb-4">
            <div className="flex justify-between items-center mb-2">
              <label className="block text-sm font-medium">JSON da importare:</label>
              <button
                onClick={loadExample}
                className="text-sm text-blue-600 hover:text-blue-800"
              >
                Carica esempio
              </button>
            </div>
            <textarea
              value={jsonInput}
              onChange={(e) => {
                setJsonInput(e.target.value);
                setError('');
              }}
              placeholder='{"1": [{"Word": "hello", "Language": "English"}]}'
              className="w-full h-64 px-3 py-2 border border-gray-300 rounded font-mono text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">
              {error}
            </div>
          )}

          <div className="mb-4 p-4 bg-blue-50 border border-blue-200 rounded">
            <h4 className="font-semibold mb-2 text-sm">Formato richiesto:</h4>
            <pre className="text-xs bg-white p-3 rounded border overflow-x-auto">
{`{
  "1": [
    { "Word": "hello", "Language": "English" },
    { "Word": "ciao", "Language": "Italian" },
    { "Word": "bonjour", "Language": "French" },
    { "Word": "hola", "Language": "Spanish" },
    { "Word": "hallo", "Language": "German" }
  ],
  "2": [
    { "Word": "water", "Language": "English" },
    { "Word": "acqua", "Language": "Italian" },
    { "Word": "eau", "Language": "French" },
    { "Word": "agua", "Language": "Spanish" },
    { "Word": "wasser", "Language": "German" }
  ],
  "3": [
    { "Word": "book", "Language": "English" },
    { "Word": "libro", "Language": "Italian" },
    { "Word": "livre", "Language": "French" },
    { "Word": "libro", "Language": "Spanish" },
    { "Word": "buch", "Language": "German" }
  ],
  "4": [
    { "Word": "house", "Language": "English" },
    { "Word": "casa", "Language": "Italian" },
    { "Word": "maison", "Language": "French" },
    { "Word": "casa", "Language": "Spanish" },
    { "Word": "haus", "Language": "German" }
  ],
  "5": [
    { "Word": "time", "Language": "English" },
    { "Word": "tempo", "Language": "Italian" },
    { "Word": "temps", "Language": "French" },
    { "Word": "tiempo", "Language": "Spanish" },
    { "Word": "zeit", "Language": "German" }
  ]
}`}
            </pre>
            <ul className="mt-2 text-xs text-gray-600 space-y-1">
              <li>• Le chiavi devono essere numeri</li>
              <li>• Ogni valore è un array di oggetti WordReference</li>
              <li>• Ogni WordReference deve avere "Word" e "Language"</li>
              <li>• Lingue supportate: English, Italian, Spanish, French, German</li>
            </ul>
          </div>

          <div className="flex gap-3 justify-end">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
              disabled={loading}
            >
              Annulla
            </button>
            <button
              onClick={handleImport}
              disabled={loading}
              className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center gap-2 disabled:bg-gray-400"
            >
              <Upload size={18} />
              {loading ? 'Importazione...' : 'Importa'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};



// Breadcrumb Component
const Breadcrumb = ({ items }) => {
  return (
    <div className="bg-gray-100 px-4 py-3 rounded mb-4 text-sm text-gray-600">
      {items.map((item, index) => (
        <span key={index}>
          {index > 0 && <span className="mx-2">/</span>}
          <span className="font-medium text-blue-600">{item}</span>
        </span>
      ))}
    </div>
  );
};

// Organization Selection Component
const OrganizationSelection = ({ onSelect }) => {
  const [orgId, setOrgId] = useState('');
  const [savedOrgs, setSavedOrgs] = useState([]);
  
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem('savedOrgs') || '[]');
    setSavedOrgs(saved);
  }, []);
  
  const handleSelect = () => {
    if (!orgId.trim()) return;
    
    const updated = [...new Set([...savedOrgs, orgId])];
    localStorage.setItem('savedOrgs', JSON.stringify(updated));
    setSavedOrgs(updated);
    onSelect(orgId);
  };
  
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Seleziona Organizzazione</h2>
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Organization ID:</label>
        <input
          type="text"
          list="orgList"
          value={orgId}
          onChange={(e) => setOrgId(e.target.value)}
          placeholder="Inserisci Organization ID"
          className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          onKeyPress={(e) => e.key === 'Enter' && handleSelect()}
        />
        <datalist id="orgList">
          {savedOrgs.map((org, idx) => (
            <option key={idx} value={org} />
          ))}
        </datalist>
      </div>
      <button
        onClick={handleSelect}
        className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        Carica Argomenti
      </button>
    </div>
  );
};

// Arguments List Component
const ArgumentsList = ({ orgId, onSelect, onBack }) => {
  const [argument, setArgument] = useState('');
  const [savedArguments, setSavedArguments] = useState([]);
  
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem(`arguments_${orgId}`) || '[]');
    setSavedArguments(saved);
  }, [orgId]);
  
  const handleSelect = () => {
    if (!argument.trim()) return;
    
    const updated = [...new Set([...savedArguments, argument])];
    localStorage.setItem(`arguments_${orgId}`, JSON.stringify(updated));
    setSavedArguments(updated);
    onSelect(argument);
  };
  
  return (
    <div>
      <Breadcrumb items={[orgId]} />
      <h2 className="text-xl font-semibold mb-4">Argomenti Disponibili</h2>
      
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Argomento:</label>
        <input
          type="text"
          list="argumentsList"
          value={argument}
          onChange={(e) => setArgument(e.target.value)}
          placeholder="Seleziona o inserisci nuovo argomento"
          className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          onKeyPress={(e) => e.key === 'Enter' && handleSelect()}
        />
        <datalist id="argumentsList">
          {savedArguments.map((arg, idx) => (
            <option key={idx} value={arg} />
          ))}
        </datalist>
      </div>
      
      <div className="flex gap-2">
        <button
          onClick={handleSelect}
          className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Vai al Glossario
        </button>
        <button
          onClick={onBack}
          className="px-6 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 flex items-center gap-2"
        >
          <ArrowLeft size={18} />
          Indietro
        </button>
      </div>
      
      {savedArguments.length > 0 && (
        <div className="mt-6">
          <h3 className="font-medium mb-2">Argomenti salvati:</h3>
          <div className="space-y-2">
            {savedArguments.map((arg, idx) => (
              <div
                key={idx}
                onClick={() => setArgument(arg)}
                className="p-3 bg-gray-100 hover:bg-gray-200 rounded cursor-pointer border-2 border-transparent hover:border-blue-500"
              >
                {arg}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

// Word Reference Input Component
const WordReferenceInput = ({ onRemove, value, onChange }) => {
  return (
    <div className="flex gap-2 mb-2">
      <input
        type="text"
        placeholder="Parola"
        value={value.word}
        onChange={(e) => onChange({ ...value, word: e.target.value })}
        className="flex-1 px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <select
        value={value.language}
        onChange={(e) => onChange({ ...value, language: e.target.value })}
        className="px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="English">English</option>
        <option value="Italian">Italian</option>
        <option value="Spanish">Spanish</option>
        <option value="French">French</option>
        <option value="German">German</option>
      </select>
      <button
        onClick={onRemove}
        className="px-3 py-2 bg-red-500 text-white rounded hover:bg-red-600"
      >
        <X size={18} />
      </button>
    </div>
  );
};

// Add Word Form Component
const AddWordForm = ({ orgId, argument, onSuccess, onCancel }) => {
  const [word, setWord] = useState('');
  const [language, setLanguage] = useState('English');
  const [rule, setRule] = useState('');
  const [logic, setLogic] = useState('intersection');
  const [wordReferences, setWordReferences] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSimilarModal, setShowSimilarModal] = useState(false);
  const [similarWords, setSimilarWords] = useState([]);
  const [checkingWord, setCheckingWord] = useState(false);
  
  const addReference = () => {
    setWordReferences([...wordReferences, { word: '', language: 'English' }]);
  };
  
  const updateReference = (index, value) => {
    const updated = [...wordReferences];
    updated[index] = value;
    setWordReferences(updated);
  };
  
  const removeReference = (index) => {
    setWordReferences(wordReferences.filter((_, i) => i !== index));
  };
  
  const handleCheckSimilarWords = async () => {
    if (!word.trim()) {
      alert('Inserisci una parola prima di controllare');
      return;
    }

    setCheckingWord(true);

    try {
      const result = await apiService.checkSimilarWords(
        orgId, 
        argument, 
        word, 
        language
      );
      
      setSimilarWords(result);
      setShowSimilarModal(true);
    } catch (error) {
      alert(`Errore durante il controllo: ${error.message}`);
    } finally {
      setCheckingWord(false);
    }
  };
  
  const handleSubmit = async () => {
    if (!word.trim()) {
      alert('Inserisci una parola');
      return;
    }
    
    setLoading(true);
    
    const payload = {
      Word: word,
      Language: language,
      Rule: rule || null,
      Words: wordReferences
        .filter(ref => ref.word.trim())
        .map(ref => ({ Word: ref.word, Language: ref.language })),
      Logic: logic
    };
    
    try {
      const result = await apiService.insertWord(orgId, argument, payload);
      
      // Gestisci in base al tipo di risposta
      if (result.type === 'success') {
        // isSuccess: true, isWarning: false
        onSuccess(result.data.message, 'success');
        // Reset form solo in caso di successo
        setWord('');
        setRule('');
        setWordReferences([]);
      } else if (result.type === 'warning') {
        // isSuccess: false, isWarning: true
        onSuccess(result.data.message, 'warning');
      } else {
        // isSuccess: false, isWarning: false (errore 500 o altro)
        onSuccess(result.data.message || 'Errore durante l\'inserimento', 'error');
      }
    } catch (error) {
      onSuccess(`Errore di rete: ${error.message}`, 'error');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="bg-gray-50 p-5 rounded border border-gray-200 mb-6">
      <h3 className="text-lg font-semibold mb-4">Aggiungi Nuova Parola</h3>
      
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Parola:</label>
        <input
          type="text"
          value={word}
          onChange={(e) => setWord(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Lingua:</label>
        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="English">English</option>
          <option value="Italian">Italian</option>
          <option value="Spanish">Spanish</option>
          <option value="French">French</option>
          <option value="German">German</option>
        </select>
      </div>
      
      <div className="mb-3">
        <button
          onClick={handleCheckSimilarWords}
          disabled={checkingWord || !word.trim()}
          className="px-4 py-2 bg-cyan-500 text-white text-sm rounded hover:bg-cyan-600 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-2"
        >
          <CheckCircle size={16} />
          {checkingWord ? 'Controllo...' : 'Check Simili'}
        </button>
      </div>
      
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Regola (opzionale):</label>
        <input
          type="text"
          value={rule}
          onChange={(e) => setRule(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Logica:</label>
        <select
          value={logic}
          onChange={(e) => setLogic(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="intersection">Intersection</option>
          <option value="union">Union</option>
        </select>
      </div>
      
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Parole di Riferimento:</label>
        <button
          onClick={addReference}
          className="mb-2 px-3 py-2 bg-green-500 text-white rounded hover:bg-green-600 flex items-center gap-2 text-sm"
        >
          <Plus size={16} />
          Aggiungi Riferimento
        </button>
        {wordReferences.map((ref, index) => (
          <WordReferenceInput
            key={index}
            value={ref}
            onChange={(value) => updateReference(index, value)}
            onRemove={() => removeReference(index)}
          />
        ))}
      </div>
      
      <div className="flex gap-2">
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-gray-400"
        >
          {loading ? 'Inserimento...' : 'Inserisci Parola'}
        </button>
        <button
          onClick={onCancel}
          className="px-6 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
        >
          Annulla
        </button>
      </div>

      {showSimilarModal && (
        <SimilarWordsModal
          similarWords={similarWords}
          onClose={() => setShowSimilarModal(false)}
        />
      )}
    </div>
  );
};

// Glossary Card Component
const GlossaryCard = ({ entry, index, meaningId }) => {
  // Colori diversi per le lingue
  const languageColors = {
    'English': 'bg-blue-500 text-white',
    'Italian': 'bg-green-500 text-white',
    'Spanish': 'bg-red-500 text-white',
    'French': 'bg-purple-500 text-white',
    'German': 'bg-yellow-500 text-gray-900',
  };
  
  const getLanguageColor = (lang) => languageColors[lang] || 'bg-gray-500 text-white';
  
  return (
    <div className="group relative bg-gradient-to-br from-white to-gray-50 border border-gray-200 rounded-xl p-5 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 overflow-hidden">
      {/* Decorative corner */}
      <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-blue-500/10 to-purple-500/10 rounded-bl-full transform translate-x-8 -translate-y-8 group-hover:scale-150 transition-transform duration-500"></div>
      
      {/* Header */}
      <div className="flex items-center justify-between mb-4 relative z-10">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center text-white font-bold text-sm shadow-lg">
            {index + 1}
          </div>
          <span className="text-xs font-semibold text-gray-600">
            Gruppo di traduzione #{meaningId}
          </span>
        </div>
        <div className="flex items-center gap-1 bg-gray-100 px-2.5 py-1 rounded-full">
          <span className="text-xl">🌍</span>
          <span className="text-xs font-bold text-gray-700">
            {entry.length}
          </span>
        </div>
      </div>
      
      {/* Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent mb-4"></div>
      
      {/* Languages */}
      <div className="space-y-3 relative z-10">
        {entry.map((item, idx) => (
          <div 
            key={idx} 
            className="flex items-center gap-3 p-2.5 rounded-lg bg-white/50 hover:bg-white transition-all duration-200 group/item"
            style={{ animationDelay: `${idx * 50}ms` }}
          >
            <span className={`text-xs font-bold ${getLanguageColor(item.language)} px-3 py-1.5 rounded-md shadow-sm min-w-[90px] text-center uppercase tracking-wide`}>
              {item.language}
            </span>
            <span className="text-base font-semibold text-gray-800 flex-1 group-hover/item:text-blue-600 transition-colors">
              {item.word}
            </span>
          </div>
        ))}
      </div>
      
      {/* Hover indicator */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
    </div>
  );
};

// Glossary View Component
const GlossaryView = ({ orgId, argument, onBack }) => {
  const [glossary, setGlossary] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [showDeleteForm, setShowDeleteForm] = useState(false); // NUOVO
  const [showImportModal, setShowImportModal] = useState(false); // NUOVO per import
  const [showTestGlossaryModal, setShowTestGlossaryModal] = useState(false); // NUOVO per test glossary
  const [message, setMessage] = useState(null);
  
  const loadGlossary = async () => {
    setLoading(true);
    try {
      const data = await apiService.getGlossary(orgId, argument);
      setGlossary(data);
    } catch (error) {
      setMessage({ text: `Errore: ${error.message}`, type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const deleteGlossary = async () => {
    setLoading(true);
    try {
      await apiService.deleteGlossary(orgId, argument);
      loadGlossary()
    } catch (error) {
      setMessage({ text: `Errore: ${error.message}`, type: 'error' });
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    loadGlossary();
  }, []);
  
  const handleAddSuccess = (msg, type) => {
    console.log('Setting message:', msg, type);
    setMessage({ text: msg, type });
    if (type === 'success') {
      setShowAddForm(false);
      loadGlossary();
    }
  };
  
  const handleDeleteSuccess = (msg, type) => {
    console.log('Setting message:', msg, type);
    setMessage({ text: msg, type });
    if (type === 'success' || type === "warning") {
      setShowDeleteForm(false);
      loadGlossary();
    }
  };

  const handleImportSuccess = (msg, type) => {
    console.log('Setting message:', msg, type);
    setMessage({ text: msg, type });
    if (type === 'success') {
      setShowImportModal(false);
      loadGlossary();
    }
  };
  
  return (
    <div>
      <Breadcrumb items={[orgId, argument]} />
      
      <h2 className="text-xl font-semibold mb-4">Glossario</h2>
      
      {message && (
        <Message
          message={message.text}
          type={message.type}
          onClose={() => setMessage(null)}
        />
      )}
      
      <div className="flex gap-2 mb-6">
        <button
          onClick={loadGlossary}
          disabled={loading}
          className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center gap-2 disabled:bg-gray-400"
        >
          <RefreshCcw size={18} />
          {loading ? 'Caricamento...' : 'Ricarica Glossario'}
        </button>
        <button
          onClick={() => {
            setShowAddForm(!showAddForm);
            setShowDeleteForm(false); // Chiudi l'altro form
          }}
          className="px-6 py-2 bg-green-500 text-white rounded hover:bg-green-600 flex items-center gap-2"
        >
          <Plus size={18} />
          Aggiungi Parola
        </button>
        <button
          onClick={() => {
            setShowDeleteForm(!showDeleteForm);
            setShowAddForm(false); // Chiudi l'altro form
          }}
          className="px-6 py-2 bg-red-500 text-white rounded hover:bg-red-600 flex items-center gap-2"
        >
          <Trash2 size={18} />
          Elimina Parola
        </button>
        
        <button
          onClick={() => {
            setShowImportModal(true);
            setShowAddForm(false);
            setShowDeleteForm(false);
          }}
          className="px-6 py-2 bg-purple-600 text-white rounded hover:bg-purple-700 flex items-center gap-2"
        >
          <Upload size={18} />
          Import JSON
        </button>
        <button
          onClick={() => {
            setShowTestGlossaryModal(true);
            setShowAddForm(false);
            setShowDeleteForm(false);
          }}
          className="px-6 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 flex items-center gap-2"
        >
          <FileJson size={18} />
          Test TU
        </button>
         <button
          onClick={() => {
            deleteGlossary()
            setShowAddForm(false); // Chiudi l'altro form
          }}
          className="px-6 py-2 bg-red-400 text-white rounded hover:bg-red-600 flex items-center gap-2"
        >
          <Trash2 size={18} />
          Elimina Glossario
        </button>
        <button
          onClick={onBack}
          className="px-6 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 flex items-center gap-2"
        >
          <ArrowLeft size={18} />
          Indietro
        </button>
      </div>
      
      {showAddForm && (
        <AddWordForm
          orgId={orgId}
          argument={argument}
          onSuccess={handleAddSuccess}
          onCancel={() => setShowAddForm(false)}
        />
      )}
      
      {showDeleteForm && (
        <DeleteWordForm
          orgId={orgId}
          argument={argument}
          onSuccess={handleDeleteSuccess}
          onCancel={() => setShowDeleteForm(false)}
        />
      )}

      {showImportModal && (
        <ImportModal
          orgId={orgId}
          argument={argument}
          onSuccess={handleImportSuccess}
          onClose={() => setShowImportModal(false)}
        />
      )}

      {showTestGlossaryModal && (
        <TestGlossaryModal
          orgId={orgId}
          argument={argument}
          onClose={() => setShowTestGlossaryModal(false)}
        />
      )}
      
      {loading ? (
        <div className="text-center py-10 text-gray-500">Caricamento...</div>
      ) : glossary.length === 0 ? (
        <div className="text-center py-10 text-gray-500 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
          <p className="text-lg mb-2">📚 Nessuna entry trovata nel glossario</p>
          <p className="text-sm">Inizia aggiungendo la prima parola!</p>
        </div>
      ) : (
        <div>
          <div className="mb-4 text-sm text-gray-600 bg-blue-50 p-3 rounded border border-blue-200">
            <strong>{Object.keys(glossary).length}</strong> {Object.keys(glossary).length === 1 ? 'gruppo trovato' : 'gruppi trovati'}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {Object.keys(glossary).map((meaningId, idx) => (
              <GlossaryCard 
                key={meaningId} 
                entry={glossary[meaningId]} 
                index={idx} 
                meaningId={meaningId} 
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const DeleteWordForm = ({ orgId, argument, onSuccess, onCancel }) => {
  const [word, setWord] = useState('');
  const [language, setLanguage] = useState('English');
  const [loading, setLoading] = useState(false);
  
  const handleSubmit = async () => {
    if (!word.trim()) {
      alert('Inserisci una parola');
      return;
    }
    
    if (!window.confirm(`Sei sicuro di voler eliminare "${word}" (${language})?`)) {
      return;
    }
    
    setLoading(true);
    
    try {
      const result = await apiService.deleteWord(orgId, argument, word, language);
       // Gestisci in base al tipo di risposta
      if (result.type === 'success') {
        // isSuccess: true, isWarning: false
        onSuccess(result.data.message, 'success');
        // Reset form solo in caso di successo
        setWord('');
      } else if (result.type === 'warning') {
        // isSuccess: false, isWarning: true
        onSuccess(result.data.message, 'warning');
      } else {
        // isSuccess: false, isWarning: false (errore 500 o altro)
        onSuccess(result.data.message || 'Errore durante la cancellazione', 'error');
      }  
    } catch (error) {
      onSuccess(`Errore di rete: ${error.message}`, 'error');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="bg-red-50 p-5 rounded border border-red-200 mb-6">
      <h3 className="text-lg font-semibold mb-4 text-red-800">Elimina Parola</h3>
      
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Parola:</label>
        <input
          type="text"
          value={word}
          onChange={(e) => setWord(e.target.value)}
          placeholder="Inserisci la parola da eliminare"
          className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
        />
      </div>
      
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Lingua:</label>
        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
        >
          <option value="English">English</option>
          <option value="Italian">Italian</option>
          <option value="Spanish">Spanish</option>
          <option value="French">French</option>
          <option value="German">German</option>
        </select>
      </div>
      
      <div className="flex gap-2">
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="px-6 py-2 bg-red-600 text-white rounded hover:bg-red-700 disabled:bg-gray-400"
        >
          {loading ? 'Eliminazione...' : 'Elimina Parola'}
        </button>
        <button
          onClick={onCancel}
          className="px-6 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
        >
          Annulla
        </button>
      </div>
    </div>
  );
};
// Main App Component
export default function GlossaryManager() {
  const [currentView, setCurrentView] = useState('org');
  const [orgId, setOrgId] = useState('');
  const [argument, setArgument] = useState('');
  
  const handleOrgSelect = (id) => {
    setOrgId(id);
    setCurrentView('arguments');
  };
  
  const handleArgumentSelect = (arg) => {
    setArgument(arg);
    setCurrentView('glossary');
  };
  
  const handleBackToOrg = () => {
    setCurrentView('org');
    setOrgId('');
    setArgument('');
  };
  
  const handleBackToArguments = () => {
    setCurrentView('arguments');
    setArgument('');
  };
  
  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-3xl font-bold mb-6 pb-3 border-b-4 border-blue-600">
          📚 Glossary Manager
        </h1>

<h4 className="text-l mb-4"><b>Organization Id</b> e <b>Argument</b> servono per poter navigare nelle rotte. Al primo accesso dovrai inserirli manualmente, ma verranno salvati nella sessione del browser e suggeriti automaticamente nelle visite successive. Se si inserisce un organizzazione e argomento in cui sono gia state inserite parole precedentemente vengono caricate </h4>
      
        
        {currentView === 'org' && (
          <OrganizationSelection onSelect={handleOrgSelect} />
        )}
        
        {currentView === 'arguments' && (
          <ArgumentsList
            orgId={orgId}
            onSelect={handleArgumentSelect}
            onBack={handleBackToOrg}
          />
        )}
        
        {currentView === 'glossary' && (
          <GlossaryView
            orgId={orgId}
            argument={argument}
            onBack={handleBackToArguments}
          />
        )}
      </div>
    </div>
  );
}